import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours'
import { TouchableOpacity } from 'react-native'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import TableInvitesPage from '../tableInvites/TableInvitesPage'
import * as SecureStore from 'expo-secure-store';
import CelebratoriesNotification from './CelebratoriesNotification'
import TableInvitesNotifications from './TableInvitesNotifications'


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const NotificationScreen = ({ tableInvites, getNotificationData, setTableInvites, setNotificationCount, notificationData }) => {

    const [showTableInvitePage, setShowTableInvitePage] = useState(false)
    const [tableInviteVisible, setTableInviteVisible] = useState(true)

    const [showTableInvitesNotifications, setShowTableInvitesNotifications] = useState(false)
    const [showCelebratoriesNotification, setShowCelebratoriesNotification] = useState(false)
    // const [celebrateCount, setShowCelebrateCount] = useState(false)
    // const [inviteCount, setShowInviteCount] = useState(false)

    useEffect(() => {
        //console.log('notificationData', notificationData)
    }, [])

    // Count tableInvites unseen
    const unseenTableInvitesCount = notificationData?.filter(
        (n) => n.type === "tableInvite" && n.seen === false
    ).length || 0;

    // Count celebratories unseen
    const unseenCelebratoriesCount = notificationData?.filter(
        (n) => n.type === "celebratory" && n.seen === false
    ).length || 0;


    const handleShowTableInvite = () => {
        setShowTableInvitePage(true)
    }

    // const refreshSeenStatus = async () => {
    //     const seenInvites = await SecureStore.getItemAsync('hasSeenInvites');
    //     const seenCelebrate = await SecureStore.getItemAsync('hasSeenCelebratories');

    //     //  setShowInviteCount(seenInvites !== 'true');
    //     //  setShowCelebrateCount(seenCelebrate !== 'true');

    //     if (seenInvites === 'true' && seenCelebrate === 'true') {
    //         setNotificationCount(0);
    //     }
    // };


    useEffect(() => {
        const checkSeenAndUnSeen = async () => {
            const seenInvites = await SecureStore.getItemAsync('hasSeenInvites');
            const seenCelebrate = await SecureStore.getItemAsync('hasSeenCelebratories')
            if (seenInvites === 'true' && seenCelebrate === 'true') {
                setNotificationCount(0)
            }
            // setShowInviteCount(seenInvites !== 'true');
            // setShowCelebrateCount(seenCelebrate !== 'true');
        }
        checkSeenAndUnSeen()
    }, [])


    return (
        <View>
            <ScrollView
                style={styles.componentStyle}
                contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
                showsVerticalScrollIndicator={false}
            >
                <View style={styles.notificationItemsStyle}>

                    <TouchableOpacity style={styles.profileContainer}
                        onPress={async () => {
                            //  await SecureStore.setItemAsync('hasSeenInvites', 'false');
                            // refreshSeenStatus()
                            setShowTableInvitesNotifications(true)
                        }}
                    >
                        <View >
                            <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular', width: dynamicSize(260) }}>
                                Table Invites - <Text style={{ color: Colours.PRIMARY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}> {unseenTableInvitesCount}</Text>
                            </Text>
                        </View>
                    </TouchableOpacity>

                    <TouchableOpacity style={styles.profileContainer}
                        onPress={async () => {
                            //  await SecureStore.setItemAsync('hasSeenCelebratories', 'false');
                            // refreshSeenStatus()
                            setShowCelebratoriesNotification(true)
                        }}
                    >
                        <View >
                            <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular', width: dynamicSize(260) }}>
                                Celebratories - <Text style={{ color: Colours.PRIMARY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}> {unseenCelebratoriesCount}</Text>
                            </Text>
                        </View>
                    </TouchableOpacity>


                    {/* <FlatList
                        data={tableInvites}
                        scrollEnabled={false}
                        renderItem={({ item: invites }) => (
                            <TouchableOpacity style={styles.profileContainer}
                                onPress={handleShowTableInvite}>
                                {invites.userID.profilePicture ? (<Image source={{ uri: invites?.userID?.profilePicture }} style={styles.userImage} />
                                ) : (
                                    <Image source={require('../../../assets/profile_image_holder.jpg')} style={styles.userImage} />
                                )}
                                <View >
                                    <Text style={{ color: Colours.DARKGRAY, fontSize: 15, fontFamily: 'Sen-Regular', width: 260 }}>
                                        You have been invited by<Text style={{ color: Colours.PRIMARY, fontSize: 15, fontFamily: 'Sen-Regular' }}> "{invites?.userID?.username}"</Text>
                                        to join the table<Text style={{ color: Colours.PRIMARY, fontSize: 15, fontFamily: 'Sen-Regular' }}> "{invites?.tableCaption}" </Text>
                                    </Text>
                                </View>
                            </TouchableOpacity>)
                        } /> */}

                </View>
            </ScrollView>

            {/* <Modal
                animationType='fade'
                visible={showTableInvitePage}
                onRequestClose={() => setShowTableInvitePage(false)}
            >
                <TopHeaderComponent headerText={'Table Invites'} hideScreen={() => setShowTableInvitePage(false)} />
                <TableInvitesPage tableInvites={tableInvites}
                    setTableInviteVisible={setTableInviteVisible}
                    tableInviteVisible={tableInviteVisible}
                    getTableInvites={getTableInvites}
                    setTableInvites={setTableInvites}
                />
            </Modal> */}

            <Modal
                animationType='fade'
                visible={showTableInvitesNotifications}
                onRequestClose={() => {
                    setShowTableInvitesNotifications(false)
                    getNotificationData()
                }}
            >
                <TopHeaderComponent headerText={'My Table Invites'} hideScreen={() => {
                    setShowTableInvitesNotifications(false)
                    getNotificationData()
                }} />
                <TableInvitesNotifications
                    tableInvites={tableInvites}
                    getNotificationData={getNotificationData}
                    setTableInvites={setTableInvites}

                    notificationData={notificationData}
                />
            </Modal>


            <Modal
                animationType='fade'
                visible={showCelebratoriesNotification}
                onRequestClose={() => {
                    setShowCelebratoriesNotification(false)
                    getNotificationData()
                }}
            >
                <TopHeaderComponent headerText={'My Celebratories'} hideScreen={() => {
                    setShowCelebratoriesNotification(false)
                    getNotificationData()
                }} />
                <CelebratoriesNotification

                    notificationData={notificationData}
                />
            </Modal>

        </View>
    )
}

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        height: '100%',
    },
    // notificationItemsStyle: {
    //     display: 'flex',
    //     backgroundColor: 'white',
    //     margin: 15,
    //     padding: 10,
    //     borderRadius: 15,

    // },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: dynamicSpacing(15),
        marginBottom: 0,
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
        borderRadius: dynamicSize(15),

        gap: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(45),
        height: dynamicSize(45),
        borderRadius: dynamicSize(99),

    }
})

export default NotificationScreen
